import Vue from 'vue'
import Vuex from 'vuex'
import Permission from './modules/permission';
import UtilitiesApi from '../api/utilities-api';
import ReservationApi from "../api/reservation-api";
import ChatApi from "../api/chat-api";
import router from "./../router";
Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    permission: Permission
  },
  state: {
    UserDetails: null,
    ReservationConfig: null,
    ActiveLocation: null,
    Tenant: null,
    ActiveShift: null,
    TempGuest: null,
    Version: null,
    ChatMessageList: null,
    IsInit: false,
    IsShowModifiedReservation: false,
    IsLoginLog: false
  },
  mutations: {
    SetUserDetails(state, data) {
      state.UserDetails = data;
    },
    SetReservationConfig(state, data) {
      state.ReservationConfig = data;
    },
    SetActiveLocation(state, data) {
      state.ActiveLocation = data;
    },
    SetTenant(state, data) {
      state.Tenant = data;
    },
    SetActiveShift(state, data) {
      state.ActiveShift = data;
    },
    SetTempGuest(state, data) {
      state.TempGuest = data;
    },
    SetVersion(state, data) {
      state.Version = data;
    },
    SetChatMessageList(state, data) {
      state.ChatMessageList = data;
    },
    SetInit(state, data) {
      state.IsInit = data;
    },
    SetIsShowModifiedReservation(state, data) {
      state.IsShowModifiedReservation = data;
    },
    SetLoginLog(state, data) {
      state.IsLoginLog = data;
    }
  },
  getters: {
    GetUserRanks: state => {

      if (!state.UserDetails) return null;

      const user = state.UserDetails.user;
      return {
        isUserAdminRank: user.isUserAdminRank,
        isUserTenantRank: user.isUserTenantRank,
        isUserCompanyRank: user.isUserCompanyRank,
        isUserPropertyRank: user.isUserPropertyRank
      }
    },
    GetDefaultCurrency: state => {
      return () => {
        if (state.ReservationConfig !== null) {
          return state.ReservationConfig.propertyCurrencies.find((c) => { return c.isActive && c.isDefault }).currency;
        }
        return null;
      }
    },
    GetReservationConfig: state => {
      if (state.ReservationConfig === null) {
        return null;
      }
      return state.ReservationConfig;
    },
    GetReservationConfigFn: state => {

      return () => {
        if (state.ReservationConfig === null) {
          return null;
        }
        return state.ReservationConfig;
      }

      return null;
    },
    GetBookingStatus: state => {

      return (id) => {
        if (state.ReservationConfig !== null) {
          let status = state.ReservationConfig.bookingStatuses.find((item) => item.id === id);

          return status && status.name || '';

        }
        return '';
      };
    },
    TranslateText: state => {
      return (text) => {

        if (!text)
          return;

        const languageStorage = localStorage.getItem('lang');

        if (!languageStorage)
          return text;

        const language = JSON.parse(languageStorage);

        if (language.languageName === 'English') {
          return text;
        }


        let languageTranslated = language.languageTranslated.find((item) => item.defaultText.trim().toLowerCase() === text.trim().toLowerCase());

        if (languageTranslated)
          return languageTranslated.translatedText;

        return text;
      }
    },
    GetLanguage: state => {
      return () => {
        const languageStorage = localStorage.getItem('lang');

        if (!languageStorage)
          return 'English';

        const language = JSON.parse(languageStorage);

        return language.languageName;

      }
    },
    GetOtherLanguage: state => {
      return () => {
        const languageStorage = localStorage.getItem('tempLang');

        if (!languageStorage)
          return null;

        const language = JSON.parse(languageStorage);

        return language;
      }
    },
    GetBookingStatusFn: state => {
      return () => {
        if (state.ActiveLocation === null) {
          let activeLocation = JSON.parse(localStorage.getItem('activeLocation'));
          return activeLocation !== undefined ? activeLocation : null;
        }
        return state.ActiveLocation;
      };
    },
    GetVersion: state => {
      return () => {
        if (state.Version === null) {
          let version = localStorage.getItem('pmsversion');
          return version || "";
        }
        return state.Version;
      };
    },
    GetActiveLocation: state => {
      if (state.ActiveLocation === null) {
        let activeLocation = JSON.parse(localStorage.getItem('activeLocation'));
        return activeLocation !== undefined ? activeLocation : null;
      }
      return state.ActiveLocation;
    },
    GetActiveLocationFn: state => {

      return () => {
        if (state.ActiveLocation === null) {
          let activeLocation = JSON.parse(localStorage.getItem('activeLocation'));
          return activeLocation !== undefined ? activeLocation : null;
        }
        return state.ActiveLocation;
      };


    },
    GetCurrentUser: () => {

      let accessDetails = JSON.parse(localStorage.getItem('access_details'));

      if (!accessDetails) {
        return null;
      }

      return accessDetails;
    },
    GetCurrentUserFn: () => {

      return () => {
        let accessDetails = JSON.parse(localStorage.getItem('access_details'));

        if (!accessDetails) {
          return null;
        }

        return accessDetails;
      };
    },
    GetInitFn: state => {

      return () => {
        return state.IsInit
      }
    },
    GetIsShowModifiedReservation: state => {
      return state.IsShowModifiedReservation
    },
    GetTenant: state => {
      return () => {
        if (state.Tenant === null) {
          let tenant = localStorage.getItem('pmstenant');
          return tenant ? JSON.parse(tenant) : null;
        }
        return state.Tenant;
      }
    },
    GetActiveShift: state => {
      return state.ActiveShift
    },
    GetActiveShiftFn: state => {
      return () => {
        return state.ActiveShift
      }
    },
    GetTempGuest: state => {
      return state.TempGuest
    },
    GetDepartmentFrontOffice: state => {

      return () => {

        let userClaims = state.UserDetails.user.claims;
        let userClaim = userClaims.find(uc => uc.claimType === 'DepartmentId');

        if (userClaim === undefined) {
          return false;
        }

        let dept = JSON.parse(userClaim.claimValue);

        if (dept.deptId === 1) {
          return true;
        }
        return false;
      }
    },
    GetChatMessageList: state => {
      return () => {
        return state.ChatMessageList;
      }
    },
    GetLoginLog: state => {
      return () => {
        return state.IsLoginLog;
      }
    }
  },
  actions: {
    GetUserDetails: function ({ commit, getters, state }) {
      return new Promise((resolve, reject) => {
        try {

          const user = getters.GetCurrentUserFn();
          if (!user) {
            resolve();
            return;
          }

          const userdetails = state.UserDetails;
          if (userdetails !== null && userdetails !== undefined) {
            resolve();
            return;
          }

          UtilitiesApi.getUserDetails(user.userId).then(res => {
            const resData = res.data;

            if (!resData.success) {
              throw resData.message;
            }

            const usrdtl = resData.data;
            const locations = usrdtl.locations;
            const savedLocation = getters.GetActiveLocation;

            if (savedLocation) {
              const loc = locations.find(l => l.pvid == savedLocation.pvid);

              if (!loc) {
                localStorage.removeItem('activeLocation');
              }
            }


            if (locations !== null && locations.length !== 0 && locations !== undefined) {
              let activeLocation = localStorage.getItem('activeLocation');
              if (activeLocation !== undefined && activeLocation !== null) {
                commit('SetActiveLocation', JSON.parse(activeLocation));
              } else {
                if (locations.length > 0) {
                  commit('SetActiveLocation', locations[0]);
                  localStorage.setItem('activeLocation', JSON.stringify(locations[0]));
                }
              }
            }


            commit('SetUserDetails', usrdtl);
            resolve();
          }).catch(error => {
            // console.log(error);
            reject(error);
          });
        } catch (ex) {
          // console.log(ex);
          reject(ex);
        }
      });
    },
    GetReservationConfig: function ({ commit, getters }) {

      let model = {
        PropertyId: getters.GetActiveLocation.pvid
      };

      return ReservationApi.getConfig(model).then(res => {
        const resData = res.data;

        if (!resData.success) {
          throw resData.message;
        }

        commit("SetReservationConfig", resData.data);

      }).catch(error => console.log(error));
    },
    GetTenant: function ({ commit }) {
      return new Promise((resolve, reject) => {


        UtilitiesApi.getTenant().then(res => {
          const resData = res.data;

          if (!resData.success) {
            throw resData.message;
          }

          localStorage.setItem('pmstenant', JSON.stringify(resData.data));
          commit('SetTenant', resData.data);
          resolve();
        }).catch(error => {
          // console.log(error);
          reject(error);
        });
      });
    },
    GetVersion: function ({ commit }) {
      return new Promise((resolve, reject) => {


        UtilitiesApi.getVersion().then(res => {
          const resData = res.data;

          if (!resData.success) {
            throw resData.message;
          }

          localStorage.setItem('pmsversion', resData.data);

          commit('SetVersion', resData.data);
          resolve();
        }).catch(error => {
          // console.log(error);
          reject(error);
        });
      });
    },
    GetMaintenanceStatus: function ({ commit }) {
      return new Promise((resolve, reject) => {


        UtilitiesApi.getMaintenanceStatus().then(res => {
          const resData = res.data;

          if (resData) {
            router.push({ name: "maintenance" });
          }
          resolve();
        }).catch(error => {
          // console.log(error);
          reject(error);
        });
      });
    },
    GetMessagesInfo: function ({ commit, getters }) {
      let model = {
        PropertyId: getters.GetActiveLocation.pvid
      };

      return ChatApi.GetChatMessages(model).then(res => {
        const resData = res.data;

        if (!resData.success) {
          throw resData.message;
        }

        commit("SetChatMessageList", resData.data);

      }).catch(error => console.log(error));
    },
    SetChatMessageList: function ({ commit }, messages) {
      commit('SetChatMessageList', messages);
    },
    redirectToBEWebsite: function ({ commit, getters }) {
      window.open(getters.GetActiveLocation.beWebsite, '_blank');

    }
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js